import { configureStore } from "@reduxjs/toolkit";
import plansSliceReducer from './slices/pricingPlanSlice';
import animationReducer from './slices/animationSlice';


export const store = configureStore({
  reducer: {
    plans: plansSliceReducer,
    animation: animationReducer,
  },
});

